import React from "react";

const buttonStyle = {
  width: "min(100%, 300px)",
  minHeight: "3.5rem",
  padding: "0.9rem 1.5rem",
  border: "none",
  borderRadius: "0.5rem",
  background: "linear-gradient(135deg, #002d21, #00372a)",
  color: "#e7c17f",
  cursor: "pointer",
  fontFamily: "Baskerville, serif",
  fontSize: "1.2rem",
  fontWeight: "bold",
};

export default function DailyStatusScreen({ status, currentDay, onRetry, onReturn }) {
  const loading = status === "loading";
  const unavailable = status === "unavailable";
  const title = loading
    ? "Loading today’s Chronologicle…"
    : unavailable
      ? "Today’s Chronologicle isn’t available yet."
      : "We couldn’t load today’s Chronologicle.";
  const detail = loading
    ? "Checking the daily game and historical events."
    : unavailable
      ? `Game #${currentDay ?? "—"} does not have a complete event set. Your saved games are safe.`
      : "Check your connection and try again. Your saved games are safe.";

  return (
    <main
      aria-busy={loading ? "true" : undefined}
      aria-live={loading ? "polite" : "assertive"}
      role={loading ? "status" : "alert"}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
        padding: "clamp(1rem, 5vw, 2rem)",
        background: "radial-gradient(circle at center, #03715f, #034c39)",
        color: "#e7c17f",
        fontFamily: "Baskerville, Garamond, Georgia, serif",
        textAlign: "center",
      }}
    >
      <h1 style={{ maxWidth: "42rem", margin: "0 0 0.75rem", fontSize: "clamp(2rem, 8vw, 3.25rem)", lineHeight: 1.05 }}>
        {title}
      </h1>
      <p style={{ maxWidth: "34rem", margin: "0 0 2rem", fontSize: "clamp(1rem, 4vw, 1.25rem)", lineHeight: 1.45 }}>
        {detail}
      </p>
      {!loading && (
        <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", gap: "0.75rem" }}>
          <button type="button" onClick={onRetry} style={buttonStyle}>Try Again</button>
          {onReturn && <button type="button" onClick={onReturn} style={buttonStyle}>Return to Title</button>}
        </div>
      )}
    </main>
  );
}

